import { render, staticRenderFns } from "./Rcc.vue?vue&type=template&id=72f85be4&scoped=true&"
import script from "./Rcc.vue?vue&type=script&lang=js&"
export * from "./Rcc.vue?vue&type=script&lang=js&"
import style0 from "./Rcc.vue?vue&type=style&index=0&id=72f85be4&prod&scoped=true&lang=css&"
import style1 from "./Rcc.vue?vue&type=style&index=1&id=72f85be4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f85be4",
  null
  
)

export default component.exports